import { ArrowUpRightFromSquareIcon } from "@octopusdeploy/design-system-icons";
import * as React from "react";
import type { LinkProps } from "./Link";
import { Link } from "./Link";
import { formatExternalUrl } from "./formatExternalUrl";
export type ExternalLinkProps = Pick<LinkProps, "href" | "label" | "size" | "onClick">;
export function ExternalLink({ href, label, size, onClick }: ExternalLinkProps) {
    return <Link href={formatExternalUrl(href)} label={label} trailingIcon={<ArrowUpRightFromSquareIcon size={16}/>} openInNewTab size={size} onClick={onClick}/>;
}
